import axios from 'axios';
const LABS_API_BASE_URL = '/labs';

/**
 * Fetches all available labs features for the current user
 * @returns {Promise<import('./typedefs').LabsApiFeature[]>} Array of available labs features
 */
export const getLabsFeatures = async () => {
  const response = await axios.get(`${LABS_API_BASE_URL}/features`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

/**
 * Enables a labs feature and all its constituent seller features
 * @param {string} labsFeatureId - The labs feature ID to enable
 * @returns {Promise<void>} Resolves on successful enable
 */
export const enableLabsFeature = async (labsFeatureId) => {
  const response = await axios.post(`${LABS_API_BASE_URL}/features/enable`, {
    labsFeatureId,
  });
  return response.data;
};

/**
 * Disables a labs feature and all its constituent seller features
 * @param {string} labsFeatureId - The labs feature ID to disable
 * @returns {Promise<void>} Resolves on successful disable
 */
export const disableLabsFeature = async (labsFeatureId) => {
  const response = await axios.post(`${LABS_API_BASE_URL}/features/disable`, {
    labsFeatureId,
  });
  return response.data;
};
